import { t } from '@/i18n';
import styles from './DashboardHeader.module.css';
import { isAdmin } from '@/shared/config/permissions';
import { useAuthContext } from '@/features/auth/context/AuthContext/AuthContext';

export interface DashboardHeaderProps {
  userName: string;
  companyName: string;
  companyId: string;
}

export function DashboardHeader({ userName, companyName, companyId }: DashboardHeaderProps) {
  const { userData } = useAuthContext();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) {
      return t('dashboard.header.greeting.morning');
    } else if (hour >= 12 && hour < 19) {
      return t('dashboard.header.greeting.afternoon');
    } else {
      return t('dashboard.header.greeting.night');
    }
  };

  const greeting = getGreeting();
  const trimmedName = userName.trim();

  return (
    <div className={styles.container}>
      <h3 className={styles.greeting}>
        {trimmedName
          ? t('dashboard.header.welcomeMessage', { greeting, name: trimmedName })
          : t('dashboard.header.welcomeMessageNoName', { greeting })}
      </h3>
      <div className={styles.companyInfo}>
        {isAdmin(userData.role) && <div className={styles.companyName}>{t('dashboard.header.companyName', { name: companyName })}</div>}
        <div className={styles.companyId}>{t('dashboard.header.companyId', { id: companyId })}</div>
      </div>
    </div>
  );
}

DashboardHeader.displayName = 'DashboardHeader';
